<template>
  <div id="datablog">
        <h1 class="title is-4"> Data Blog</h1>
        <!-- <div id="navbar">
            <b-navbar class="has-background-white-ter">
              
              <template slot="start">
                 <b-button  class="button is-success" 
                  tag="router-link"
                  to="/biro/datablog"
                 rounded icon-left="account-plus"
                 >Tambah News</b-button>
                
              </template>
              <template slot="end">
                <b-field position="is-centered">
                  <b-input placeholder="Search by News Title"  type="search" v-model="search" icon="magnify">
                  </b-input>
              </b-field>
              </template>
            </b-navbar>
        </div> -->
     
        <div class="rows container-1056 mt-64">
            <div class="row">
                <div class="columns">
                    <div class="column">
                        <div class="container-768">
                            <div class="card text-center" @click="showPandaiSatu">
                                <div class="div">
                                   <h1 class="title is-4 mt-16">Menu Blog</h1>
                                </div>
                                <img class="img-gambar mt-16"
                                src="https://img.freepik.com/free-photo/technology-communication-icons-symbols-concept_53876-120314.jpg?w=900&t=st=1664175748~exp=1664176348~hmac=384ad77b1e252913d4781757e15f14b57a7bfa7b1c8d458aa5b7374883177150"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="container-768">
                            <div class="card text-center" @click="showPandaiDua">
                                <div class="div">
                                    <h1 class="title is-4 mt-16"> Menu Podcast</h1>
                                </div>
                                <img
                                class="img-gambar mt-16"
                                src="https://img.freepik.com/free-vector/talking-microphone-logo-template_23-2148789042.jpg?w=740&t=st=1664175795~exp=1664176395~hmac=33fb72690aa52337069153e1c7a0de90cbf18f411871cf11f1963cda1245ddfa"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
</template>

<script>
export default {
  data() {
    return {
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      perPage:'10',
      newses:[],
      search:'',
      news:{
        title:'',
        news:'',
        picture:'',
        picture1:'',
        picture2:'',
        url:''
      },
      search:'',
      //tableLoadingIcon:'sync',
      tableMessage:'Loading...',
      detailOpened:[],
      isLoading:true,
      snackbarMessage:'',
      activeBiro: Object,
      detailId: '',
      config: {}
    }
  },
   computed:{
    filteredList()
    {
      return this.newses.filter(news=>{
        return news.title.toLowerCase().includes(this.search.toLowerCase()) 
        // news.news.toLowerCase().includes(this.search.toLowerCase()) 
      })
      
    }

  },
  methods: {
    showPandaiSatu() {
        this.$router.push('/admin/berandablog')
    },
    showPandaiDua() {
        this.$router.push('/admin/berandapodcast')
    },
    // getDataByBiro()
    // {
    //   this.isLoading=true
    //   var uri = this.$apiUrl + 'news/admin/' + this.detailId
    //   this.newses = []

    //   this.$http.get(uri, this.config).then(response =>
    //   {
    //     this.newses = response.data.value
    //     console.log(this.newses)
    //     for(var i=0; i<this.newses.length; i++)
    //     {
    //       this.newses[i].index = i+1
    //     }
    //     //this.tableLoadingIcon = "emoticon-sad"
    //     this.tableMessage ='Tidak ada data yang sesuai'
    //     this.isLoading=false
    //   })
    //   .catch(error =>{
    //     this.errors = console.error
    //     //this.tableLoadingIcon = "emoticon-sad"
    //     this.tableMessage='Tidak ada Data'
    //     this.isLoading = false
    //   })
    // },
    deleteData(deleteID)
    {
      var uri = this.$apiUrl + 'news/delete/' + deleteID

      this.$http.post(uri, null, this.config).then(response=>
      {
        this.getDataByBiro();
        this.snackbarMessage = response
        this.snackbar('Data Berhasil dihapus','is-success')
      })
      .catch(error=>
      {
        this.errors = error
        this.snackbarMessage = "Silahkan coba hapus lagi"
        this.snackbar(this.snackbarMessage,'is-danger')
      })
    },
    snackbar(message,type)
    {
      this.$buefy.toast.open({
        duration: 5000,
        message:message,
        type:type,
        position:'is-top',
        actionText:'OK',
        queue:false,
      })
    },
    confirmDelete(deleteID)
    {
      this.$buefy.dialog.confirm({
        title:'Hapus News',
        message:'Apa anda yakin ingin menghapus ?',
        confirmText:'Hapus',
        cancelText:'Batal',
        type:'is-danger',
        hasIcon:true,
        onConfirm:() =>this.deleteData(deleteID)
      })
    }  
  },
  mounted()
  {
    if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }
    this.activeBiro = this.$session.get('biro')
    if(this.activeBiro)
    {
      this.detailId = this.activeBiro.id_biro
      this.getDataByBiro()
    }
    
    console.log(this.search)
  }
}
</script>

<style scoped>
.isikonten{
  font-size: 14.5px;
  /* padding:0px; */
}

</style>